// Imported by router.tsx by direct path, not via the feature barrel: that
// barrel is the lazy chunk this route defers to, and importing it in the router
// would pull the screen back onto the eager first-paint graph (the
// ORG_SCENARIOS_PATH precedent).
export const NEW_REQUEST_PATH = "/me/requests/new";
